<template>
    <rkm-overlay>
        <rkm-layout-body title="Cancelamento de evasão">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import List from '@/components/pronto-atendimento/cancelamento-evasao/List'

export default {
    components: { List },
}
</script>